import { DEFAULT_WIDTH, tDevicesTypes } from 'students/views/shared/styled';

export const contentMaxWidth: Record<tDevicesTypes, number> = {
  mobile: 320,
  tablet: 554,
  desktop: 844
};

export const navigationBreakPoint = 890;
// customMediaQuery('mobile') falls back to this width; inside Member the theme
// overrides it with mediaQueryBreakpoints.tablet, so JS and CSS switch 44px apart.
export const mobileBreakPoint = DEFAULT_WIDTH.tablet;
export const navigationDesktopBreakPoint = 1200;

export const mediaQueryBreakpoints: Record<tDevicesTypes, number> = {
  mobile: 320,
  tablet: 600,
  desktop: 908
};
